import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

interface UserInfo {
  _id: string;
  name: string;
  email: string;
  admin: boolean;
  token: string;
}

// Get socket instance, creating one if necessary
export const getSocket = (): Socket | null => {
  const userInfo = localStorage.getItem('userInfo');

  if (!userInfo) {
    // No user logged in, disconnect if connected
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    return null;
  }

  const { token } = JSON.parse(userInfo) as UserInfo;

  if (!token) {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    return null;
  }

  // If already connected, return existing socket
  if (socket && socket.connected) {
    return socket;
  }

  // Create new socket connection
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000';

  socket = io(apiUrl, {
    auth: {
      token,
    },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  socket.on('connect', () => {
    console.log('Socket connected');
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error.message);
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected:', reason);
  });

  return socket;
};

// Disconnect socket
export const disconnectSocket = (): void => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

// Send a message via socket
export const sendMessage = (conversationId: string, content: string): void => {
  const s = getSocket();
  if (s) {
    s.emit('send_message', { conversationId, content });
  }
};

// Send typing indicator
export const sendTypingIndicator = (conversationId: string): void => {
  const s = getSocket();
  if (s) {
    s.emit('typing', { conversationId });
  }
};

const socketService = {
  getSocket,
  disconnectSocket,
  sendMessage,
  sendTypingIndicator,
};

export default socketService;
